/* GLOP v2 product page — shade switcher + colour-story refresh.
   Progressive: everything renders server-side; this only swaps state in place.
   Add-to-cart itself is Horizon's <product-form-component> (assets/product-form.js),
   which POSTs /cart/add, fires `cart:lines-update` and opens the cart drawer. */
(function () {
  /* How to use / Ingredients rows: one panel open at a time */
  function initInfo(root) {
    var toggles = root.querySelectorAll('[data-glop2-info-toggle]');
    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        var open = t.getAttribute('aria-expanded') !== 'true';
        toggles.forEach(function (o) {
          var on = o === t && open;
          o.setAttribute('aria-expanded', on ? 'true' : 'false');
          var panel = document.getElementById(o.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  }

  /* Unavailable shade: NOTIFY ME opens the GLOP pop-up (glop2-product.liquid, a Shopify
     customer form). Pages without it fall back to Restock Rocket's form, then to a
     disabled "Sold out". */
  function restockButton() {
    return document.querySelector('.restock-rocket-button-product');
  }

  function initNotify(root) {
    var add = root.querySelector('[data-glop2-add]');
    var dlg = document.querySelector('[data-glop-notify]');
    if (dlg && !dlg.hasAttribute('data-ready')) {
      dlg.setAttribute('data-ready', '');
      dlg.querySelector('[data-glop-notify-close]').addEventListener('click', function () {
        dlg.close();
      });
      // a click on the backdrop (outside the box) closes it
      dlg.addEventListener('click', function (e) {
        var r = dlg.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
      });
      // back from Shopify after a sign-up (or an error): reopen on the result
      if (location.hash === '#glop-notify-form' && dlg.querySelector('[data-glop-notify-done]')) dlg.showModal();
    }
    if (!add) return;
    add.addEventListener(
      'click',
      function (e) {
        if (!add.hasAttribute('data-glop2-notify')) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var rr = restockButton();
        if (dlg) {
          dlg.showModal();
        } else if (rr) {
          rr.click();
        } else {
          soldOut(add);
        }
      },
      true
    );
    // Without the pop-up, Restock Rocket renders its tab after load; if it never appears,
    // show the plain sold-out state.
    if (!dlg && add.hasAttribute('data-glop2-notify')) {
      window.setTimeout(function () {
        if (add.hasAttribute('data-glop2-notify') && !restockButton()) soldOut(add);
      }, 6000);
    }
  }

  function soldOut(add) {
    add.disabled = true;
    var t = add.querySelector('[data-glop2-add-text]');
    if (t) t.textContent = add.getAttribute('data-sold-out-label') || '';
  }

  function setAvailability(add, available) {
    var t = add.querySelector('[data-glop2-add-text]');
    add.disabled = false;
    if (available) {
      add.type = 'submit';
      add.removeAttribute('data-glop2-notify');
      add.removeAttribute('aria-haspopup');
      if (t) t.textContent = add.getAttribute('data-add-label') || '';
    } else {
      add.type = 'button';
      add.setAttribute('data-glop2-notify', '');
      add.setAttribute('aria-haspopup', 'dialog');
      if (t) t.textContent = add.getAttribute('data-notify-label') || add.getAttribute('data-sold-out-label') || '';
    }
  }

  /* Photo strip: mouse drag to scroll (touch scrolls natively); re-centre on resize
     until the visitor moves it */
  function initGallery(row) {
    if (row.hasAttribute('data-glop2-ready')) return;
    row.setAttribute('data-glop2-ready', '');
    var moved = false;
    var desktop = window.matchMedia('(min-width: 750px)');

    function centre() {
      if (moved || !desktop.matches) return;
      // the first photo opens in the middle of the page (data-glop2-start), else the strip's centre
      var t = row.querySelector('[data-glop2-start]');
      if (!t) {
        row.scrollLeft = (row.scrollWidth - row.clientWidth) / 2;
        return;
      }
      var tr = t.getBoundingClientRect();
      var rr = row.getBoundingClientRect();
      row.scrollLeft = row.scrollLeft + tr.left - rr.left + tr.width / 2 - row.clientWidth / 2;
    }
    centre();
    window.addEventListener('resize', centre);
    row.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', centre, { once: true });
    });

    var startX = 0;
    var startScroll = 0;
    var dragging = false;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragging = true;
      startX = e.clientX;
      startScroll = row.scrollLeft;
      row.setPointerCapture(e.pointerId);
      row.classList.add('is-dragging');
    });
    row.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      row.scrollLeft = startScroll - dx;
    });
    function end(e) {
      if (!dragging) return;
      dragging = false;
      row.classList.remove('is-dragging');
      try {
        row.releasePointerCapture(e.pointerId);
      } catch (err) {
        /* ignore */
      }
    }
    row.addEventListener('pointerup', end);
    row.addEventListener('pointercancel', end);
    // Vertical wheel/trackpad gestures over the strip always scroll the page. Browsers
    // (Safari especially) can latch a trackpad gesture onto the horizontal scroller and
    // swallow its vertical part, so vertical-dominant deltas are handed to the page's
    // scroller (Horizon's .page-wrapper on desktop, else the document) explicitly.
    function pageScroller() {
      var el = row.parentElement;
      while (el && el !== document.body) {
        var oy = window.getComputedStyle(el).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) return el;
        el = el.parentElement;
      }
      return document.scrollingElement || document.documentElement;
    }
    row.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          if (e.ctrlKey) return; // pinch-zoom
          var unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? window.innerHeight : 1;
          // 'instant': the page scroller has scroll-behavior: smooth (Horizon base.css), and a
          // smooth scroll restarted on every trackpad tick crawls
          pageScroller().scrollBy({ top: e.deltaY * unit, behavior: 'instant' });
          e.preventDefault();
        } else if (e.deltaX) {
          moved = true;
        }
      },
      { passive: false }
    );
    row.addEventListener('touchstart', function () {
      moved = true;
    }, { passive: true });
    // Scroll cue: arrow buttons step one photo; the previous arrow hides at the start
    // and the next at the end; the hint tag fades once the visitor has moved the strip
    var gallery = row.closest('[data-glop2-gallery]');
    var prevBtn = gallery && gallery.querySelector('[data-glop2-gallery-step="-1"]');
    var nextBtn = gallery && gallery.querySelector('[data-glop2-gallery-step="1"]');
    var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    function stepPhoto(dir) {
      var rowLeft = row.getBoundingClientRect().left;
      var tiles = row.querySelectorAll('.glop2-gallery__tile');
      var delta = 0;
      for (var i = 0; i < tiles.length; i++) {
        var r = tiles[i].getBoundingClientRect();
        if (!r.width) continue;
        var d = r.left - rowLeft;
        if (dir > 0 && d > 2) {
          delta = d;
          break;
        }
        if (dir < 0 && d < -2) delta = d;
      }
      if (!delta) delta = dir * row.clientWidth * 0.8;
      moved = true;
      row.scrollBy({ left: delta, behavior: smooth });
    }

    function syncNav() {
      var max = row.scrollWidth - row.clientWidth;
      var atStart = row.scrollLeft <= 1;
      var atEnd = row.scrollLeft >= max - 1;
      if (prevBtn) {
        if (atStart && prevBtn === document.activeElement && nextBtn) nextBtn.focus();
        prevBtn.hidden = atStart;
      }
      if (nextBtn) {
        if (atEnd && nextBtn === document.activeElement && prevBtn && !atStart) prevBtn.focus();
        nextBtn.hidden = atEnd || max <= 1;
      }
      if (moved && gallery) gallery.classList.add('is-moved');
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { stepPhoto(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stepPhoto(1); });
    var navQueued = false;
    row.addEventListener(
      'scroll',
      function () {
        if (navQueued) return;
        navQueued = true;
        window.requestAnimationFrame(function () {
          navQueued = false;
          syncNav();
        });
      },
      { passive: true }
    );
    window.addEventListener('resize', syncNav);
    syncNav();

    row.addEventListener('keydown', function (e) {
      var step = row.clientWidth / 3;
      if (e.key === 'ArrowRight') {
        moved = true;
        row.scrollBy({ left: step, behavior: 'smooth' });
        e.preventDefault();
      } else if (e.key === 'ArrowLeft') {
        moved = true;
        row.scrollBy({ left: -step, behavior: 'smooth' });
        e.preventDefault();
      }
    });
  }

  function initPdp(root) {
    if (root.hasAttribute('data-glop2-ready')) return;
    root.setAttribute('data-glop2-ready', '');

    initInfo(root);
    initNotify(root);

    var swatches = root.querySelectorAll('[data-glop2-swatch]');
    if (!swatches.length) return;

    var name = root.querySelector('[data-glop2-shade-name]');
    var input = root.querySelector('[data-glop2-variant-input]');
    var add = root.querySelector('[data-glop2-add]');
    var addText = root.querySelector('[data-glop2-add-text]');
    var addPrice = root.querySelector('[data-glop2-add-price]');
    var panel = root.querySelector('[data-glop2-panel]');
    var renderImg = root.querySelector('[data-glop2-render-img]');
    var productUrl = root.getAttribute('data-product-url') || '';

    function pick(index, fromUser) {
      var s = swatches[index];
      if (!s) return;

      for (var i = 0; i < swatches.length; i++) {
        swatches[i].setAttribute('aria-pressed', i === index ? 'true' : 'false');
      }

      if (name) name.textContent = s.getAttribute('data-name') || '';
      if (addPrice) addPrice.textContent = '\u00a0·\u00a0' + (s.getAttribute('data-price') || '');

      var id = s.getAttribute('data-variant-id') || '';
      if (input) input.value = id;

      var available = s.getAttribute('data-available') === 'true';
      if (add) setAvailability(add, available);

      // Shade panel colour + the variant's own image (or built-in tube). A video /
      // pinned image override renders no panel, so nothing is swapped there.
      if (panel) panel.style.setProperty('--glop2-shade-hex', s.getAttribute('data-hex') || '');
      if (renderImg) {
        var src = s.getAttribute('data-img');
        if (src && renderImg.getAttribute('src') !== src) {
          renderImg.removeAttribute('srcset');
          renderImg.src = src;
          renderImg.alt = s.getAttribute('data-alt') || renderImg.alt;
        }
      }

      if (!fromUser) return;

      // Keep the URL shareable (?variant=) without adding history entries.
      if (id && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          /* ignore */
        }
      }

      document.dispatchEvent(
        new CustomEvent('glop2:variant', {
          detail: { id: id, url: productUrl, name: s.getAttribute('data-name') || '' },
        })
      );
    }

    swatches.forEach(function (s, i) {
      s.addEventListener('click', function () {
        pick(i, true);
      });
    });
  }

  /* Colour story: re-render via the Section Rendering API when the shade changes,
     so per-variant metafields (glop.colour_story / glop.attributes) follow the swatch. */
  function initStory(root) {
    if (root.hasAttribute('data-glop2-ready')) return;
    root.setAttribute('data-glop2-ready', '');

    var sectionId = root.getAttribute('data-section-id');
    var productUrl = root.getAttribute('data-product-url');
    if (!sectionId || !productUrl || !window.fetch) return;

    var pending = 0;

    document.addEventListener('glop2:variant', function (e) {
      var id = e.detail && e.detail.id;
      if (!id) return;
      var token = ++pending;
      var url = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + encodeURIComponent(id) + '&section_id=' + encodeURIComponent(sectionId);

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          return r.ok ? r.text() : '';
        })
        .then(function (html) {
          if (!html || token !== pending) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var next = doc.querySelector('[data-glop2-story]');
          if (!next) return;
          root.innerHTML = next.innerHTML;
        })
        .catch(function () {
          /* keep what is on the page */
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-glop2-pdp]').forEach(initPdp);
    document.querySelectorAll('[data-glop2-story]').forEach(initStory);
    document.querySelectorAll('[data-glop2-gallery-row]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelector) return;
    var pdp = e.target.querySelector('[data-glop2-pdp]');
    if (pdp) initPdp(pdp);
    var story = e.target.querySelector('[data-glop2-story]');
    if (story) initStory(story);
    var row = e.target.querySelector('[data-glop2-gallery-row]');
    if (row) initGallery(row);
  });

  /* Theme editor: selecting a How to use step opens its row so the block is visible */
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target && e.target.closest && e.target.closest('.glop2-pdp__info-panel');
    if (!panel || !panel.hidden) return;
    var toggle = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (toggle) toggle.click();
  });
})();

/* Launch-shade pouch: the page loads the still first frame, then swaps in the turning
   animation once it has downloaded (never under reduced motion). */
(function () {
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function start() {
    document.querySelectorAll('img[data-glop2-spin]').forEach(function (img) {
      var url = img.getAttribute('data-glop2-spin');
      img.removeAttribute('data-glop2-spin');
      var pre = new Image();
      pre.onload = function () {
        img.src = url;
      };
      pre.src = url;
    });
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
